<script lang="ts">
  import { router } from './lib/router.svelte'
  import DocList from './routes/DocList.svelte'
  import DocView from './routes/DocView.svelte'
  import Login from './routes/Login.svelte'
  import Mcp from './routes/Mcp.svelte'

  const route = $derived(router.route)
</script>

<div class="shell">
  {#if route.name === 'doc'}
    <!--
      Keyed on the id: moving between two documents gets a fresh viewer rather
      than one carrying the previous document's revision bookkeeping, which
      would make the first update to the new document look like no change at
      all.
    -->
    {#key route.id}
      <DocView docId={route.id} />
    {/key}
  {:else if route.name === 'login'}
    <Login />
  {:else if route.name === 'mcp'}
    <Mcp />
  {:else if route.name === 'list'}
    <DocList />
  {:else}
    <!--
      Only reachable if Fastify serves the shell for a path the router does not
      know, which would be a mismatch between the two route lists.
    -->
    <main>
      <div class="measure">
        <h1 class="page-title">Not found</h1>
        <p class="empty">There is no page at <code>{route.path}</code>.</p>
        <p class="empty"><a href="/">Back to all documents</a></p>
      </div>
    </main>
  {/if}
</div>
